<template>
  <UiCard
    :tag="value.ticketsLeft ? AppRouterLink : 'button'"
    type="button"
    :to="{ name: 'SeanceView', params: { id: value.id } }"
    class="block px-5 py-4 text-left"
    :class="{ 'cursor-default': !value.ticketsLeft }"
    :disabled="!value.ticketsLeft"
  >
    <div class="mb-1 font-medium">
      <UiDate :value="value.beginsAt" :template="seanceDateTemplate" />,
      <SeanceWeekDay :value="value.beginsAt" template="EEEEEE" tag="span" />
    </div>
    <UiDate
      class="mb-2 block text-sm text-text-secondary"
      :value="value.beginsAt"
      template="HH:mm"
    />
    <p v-if="value.ticketsLeft" class="font-medium">{{ toRub(value.priceRange.min) }}</p>
    <p v-else class="font-medium text-text-secondary">распродано</p>
  </UiCard>
</template>

<script lang="ts" setup>
import { isSameYear } from 'date-fns'
import { computed } from 'vue'
import { toRub } from '@/6_shared/lib'
import { AppRouterLink, UiCard, UiDate } from '@/6_shared/ui'
import type { Seance } from '../../model'
import SeanceWeekDay from '../SeanceWeekDay.vue'

type PropType = {
  value: Seance
}

const props = defineProps<PropType>()

const seanceDateTemplate = computed(() => {
  const today = new Date()

  return isSameYear(today, props.value.beginsAt) ? `d MMMM` : `d MMMM yyyy`
})
</script>
